// extracted by mini-css-extract-plugin
export var infoRow = "_mq-2";
export var labelContainer = "_mq-0";
export var rightInfo = "_mq-1";